import React from 'react';
import PropTypes from 'prop-types';

import style from './page-layout.module.less';

const Title = ({ children = null }) => <div className={style.title}>{children}</div>;

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
